<template>
	<Container :hideFooter='env != ""' :hideHeader='env != ""' :style='{backgroundColor:backgroundColor}'>
		<TopBar v-if='!isInApp && !env'/>
		<WXHead v-if='env == "wechat"' head-title="评价" go-back='true'/>
		<div class='loading' v-if='loading'>		
			<LoadMore />
		</div>
		<div v-else class="content evalute" :env='env'>
			<div class='questions'>
				<div class='tip-title'>您真实的反馈最珍贵~</div>
				<div v-for='(q,index) in questions' :key='q.Id' class='question'>
					<div class="item" :class='q.Title.length > 7 ? "column-flex":"column-row"'>
						<p  class="topic" v-if='index  != 2'>• {{q.Title}}</p>
						<div v-if='q.QuestionType != 5' class="options">
							<RadioGroup  v-if='q.QuestionType == 1'  vertical size='large' v-model='q.select'>
								<template v-for='option in q.Answers'>
									<Radio :disabled='readonly' :key='option.Id'  :label="option.Id" size='large' class='radio'>
							            <span class="option-title" :class='readonly?"disabled-title":""'>&nbsp;&nbsp;{{option.Title}}</span>
							        </Radio>
							        <Input :disabled='readonly' :placeholder='option.Content' v-model='option.Description' style='width:80vw;' show-word-limit maxlength='200' type="textarea" :rows="4"  v-if='option.AnswerFlag == 1 && q.select == option.Id'></Input>
								</template>
							</RadioGroup>
							<CheckboxGroup @on-change='onValueChnage($event,q)'  v-else-if='q.QuestionType == 2' vertical size='large' v-model='q.select'>
								<template v-for='option in q.Answers'>
									<Checkbox :disabled='readonly' :key='option.Id' :label="option.Id" size='large' class='radio'>
							            <span class="option-title" :class='readonly?"disabled-title":""'>&nbsp;&nbsp;{{option.Title}}</span>
							        </Checkbox>
							        <Input :disabled='readonly' :placeholder='option.Content' v-model='option.Description' style='width:80vw;' show-word-limit maxlength='200' type="textarea" :rows="4"  v-if='option.AnswerFlag == 1&&q.select.indexOf(option.Id) != -1'></Input>
								</template>
								
							</CheckboxGroup>
							<Rate :disabled='readonly' @on-change='q.Description = ""' v-model="q.select" v-else-if='q.QuestionType == 6' :count='q.Answers.length'/>
						</div>
					</div>
					
					<Input :disabled='readonly' style='margin-top:15px;' v-if='q.QuestionType == 6 && showRateInput(q)' show-word-limit maxlength='200' v-model="q.Description" type="textarea" :rows="4" :placeholder="getDescPlaceholder(q,index)" /> 
					<Input :disabled='readonly' style='margin-top:15px;' v-if='q.QuestionType == 5' show-word-limit maxlength='200' v-model="q.Description" type="textarea" :rows="4" :placeholder="getDescPlaceholder(q,index)" /> 
				</div>

				
			</div>
			<div class="groups">
				<div class="group" v-for='group in groups' :key='group.Id'>
					<div class="img-box">
						<img src="@/assets/order/errorImg2.png" v-real-img="group.Img||image_path_big(group.SKU)">
					</div>
					<div class='product'>
						<div class='name'>{{group.Name}}</div>
						<div class='p-center'>
							<div v-if='specification(group.SKU)' class='specification'>{{specification(group.SKU)}}</div>
							<div class='price'>￥{{group.UnitPrice}}</div>
							<div class='quantity p-quantity'>X {{group.Quantity}}</div>
						</div>
					</div>
					<div class='quantity'>X {{group.Quantity}}</div>
				</div>
			</div>
			<div class='footer'>			
				<Button v-if='!readonly' class='submit-btn' size='large' type='primary' @click='submit'>提交，有惊喜！</Button>
			</div>
		</div>
		<iframe v-if='showIframe' class='iframe' :src="lotteryLink"></iframe>
	</Container>
</template>

<script>
	import TopBar from "@/components/common/TopBar";
	import WXHead from '@/components/header/WXHead';
	const SecretKey = '7fe3890fce12fb4836ab25evd3421eb8ceea'
	import {
		mapState,
		mapMutations,
		mapActions,
		mapGetters
	} from 'vuex'
	import {wechatUrl} from '@/config/env'
	import util from '@/config/util'
	const Delimiter = ','
	export default {
		data() {
			return {
				loading:true,
				showIframe:false,
				lotteryLink:'',
				value:0,
				value2:'',
				subjects:[],
				result:{},
				groups:[],
				orderDetail:{},
				luckyModalValue:{
					Link:''
				},
				readonly:false,

			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			TopBar,
			WXHead,
		},
		computed: {
			...mapGetters([
				'getVipNo','getAccessToken',
			]),
			...mapState({
				productInfo: state => state.order.productInfo,
				userInfo: state => state.common.wechatUserInfo,
			}),
			productMap(){
				let map = {}
				this.productInfo.value.forEach(category=>{
					category.products.forEach( product=> {
						map[product.sku] = product
					});
				});
				return map
			},
			backgroundColor(){
				if (this.env == 'app') return '#f1f1f1'
				if (this.env == 'wechat') return '#f1f1f1'
				if (this.env == 'wechatmini') return '#f1f1f1'
				return '#fff'
			},
			isInApp(){
				let isAPP = navigator.userAgent.indexOf('com.doterra.app') != -1|| this.$route.query.from=='app'
				return isAPP //&& !isWechat
			},
			env(){
				if (this.isInApp) return 'app'
				return this.$route.query.from || ""
			},
			questions(){
				let qs = this.subjects?.Questions || []
				let answers = this.result?.Detail || []
				if (!answers.length) return qs;
				let arr = []
				for (let answer of answers) {
					for (let q of qs) {
						if (q.Id == answer.QuestionID) {
							// answer和Description对应关系
							let desArr = (answer.Description ||'').split(Delimiter)
							let map = answer.Answer.split(',').reduce((prev,cur,index)=>{prev[cur] = desArr[index];return prev}, {})
							arr.push({
								Title:q.Title,
								Answer:answer.Answer,
								Options:q.Answers,
								Answers:q.Answers.map((item,index)=>({...item,Description:map[item.Id]})),
								QuestionType:q.QuestionType,
								Description:answer.Description,
								select:q.QuestionType == 2 ? answer.Answer.split(',').map(item=>parseInt(item)):parseInt(answer.Answer)
							})
							break;
						}
					}
				}
				return arr
			}
		},
		methods: {
			...mapActions([
				'getELearnExamAction',
				'getWXOrderDetailAction',
				'initProductAction',
				'submitExamAction',
				'getExamResultAction',
				'getTipDetailAction',
			]),
			getDescPlaceholder(q,index){
				if (index == 2) {
					if (this.questions[0].select != 0 && this.questions[1].select != 0) {
						if(this.questions[0].select < 4 || this.questions[1].select < 4)
						{
							return '很遗憾，请您留下宝贵意见，小多继续努力'
						}
					}
					return '展开描述下您对此单产品、购买或配送等方面的体验吧'
				}
				return q.Title
			},
			async initData(){
				document.title = '评价'
				this.luckyModalValue = await this.getTipDetailAction("Evaluate_lottery_link");
				await this.initProductAction();
				let response1 = await this.getWXOrderDetailAction(this.$route.query.orderno);
				if (response1?.group?.length) {
					this.groups = response1?.group
					this.orderDetail = response1?.detail?.[0]||{}
				}
				let response = await this.getELearnExamAction({
					ec:this.$route.query.code,
					orderno:this.$route.query?.orderno
				})
				if (response?.length) {
					let subjects = response[0]
					if (subjects.DoneRecordCode) {
						this.result = await this.getExamResultAction(subjects.DoneRecordCode)
						let subjects1= {
							Questions:this.result.QuestionDetail.map(item=>{
								item.QuestionType == 2 ? item.select = []:item.select = 0
								item.Answers.forEach(answer=>answer.Description = '')
								return {...item}
							})
						}
						this.subjects = subjects1
						this.readonly = true
						
					} else {
						subjects.Questions.forEach(item=>{
							item.QuestionType == 2 ? item.select = []:item.select = 0
							item.Answers.forEach(answer=>answer.Description = '')
						})
						this.subjects = subjects
					}
				} else {
					this.$Modal.warning({
						title:'提示',
						content:'考核题目未获取到',
						onOk:()=>{
							this.backToOrder()
						}
					})
				}
				this.loading = false
				if (this.result?.EvaluationFlag == 1) {
					this.lotteryLink = this.getLotteryLink()
					this.showIframe = true
				}
				window.addEventListener("message", (event) => {
				    if (event?.data?.action == 'close') {
				    	this.showIframe = false
				    	this.backToOrder()
				    } else if(event?.data?.action == 'showMessage') {
				    	this.$Modal.info({
				    		title:'提示',
				    		content:event?.data.data,
				    		onOk:()=>{
				    			this.backToOrder()
				    		}
				    	})
				    	
				    }
				}, false);
			},
			async backToOrder(){
				switch (this.env) {
    				case 'app':
    					const data = {
				          action: 'navigate',
				          params:{url:'OrdersList'},
				        }
    					window.ReactNativeWebView.postMessage(JSON.stringify(data))
    					break;
    				case 'wechat':
    					location.replace(`${wechatUrl}/doTERRA/index.html#/my/order`)
    					break;
    				case 'wechatmini':
    					wx.miniProgram.redirectTo({
	                        url:`/personal-sub/orders/orders`,
	                    })
    					break;
    				default:
    					this.$router.go(-1)
    					break;
    			}
			},
			async submit(){
				let isComplete = true
				let AnswerList = this.subjects.Questions.map((item,index)=>{
					let Description = item.Description
					let needDescription = false
					// 不是简述题和打分题
					if (item.QuestionType != 5 && item.QuestionType != 6) {
						let answersMap = item.Answers.reduce((prev,cur)=>{prev[cur.Id] = cur;return prev}, {})
						let select = Array.isArray(item.select) ? item.select:[item.select]
						Description = select.map(s=>answersMap[s]?.Description||'').join(',')
						needDescription = select.findIndex(s=>answersMap[s]?.AnswerFlag == 1 && !answersMap[s]?.Description) != -1
					}
					let answer = {
						QuestionCode: item.Code,	/// 题目编号
						AnswerCode: item.QuestionType == 2 ? item.select.join(','):item.select,	// 选择的答案编号,（多选时以逗号分隔）
						AnswerOrder:item.Answers.map(item=>item.Id).join(','),
						QuestionNo:index + 1,
						Description	/// 描述文字，针对简单题等
					}
					if (item.QuestionType != 5 && item.QuestionType != 6 && (!answer.AnswerCode && !Description) || needDescription) {
						isComplete = false
					}
					return answer
				})
				if (!AnswerList[0].AnswerCode|| !AnswerList[1].AnswerCode) {
					isComplete = false
				}
				if ((AnswerList[0].AnswerCode <= 3 || AnswerList[1].AnswerCode <= 3) && !AnswerList[2].Description) {
					isComplete = false
				}
				if (!isComplete) {
					this.$Modal.info({
						title:'提示',
						content:'请评价完再提交'
					})
					return
				}
				let params = {
					ExamCode:this.$route?.query.code,			//考试编号
					LessonCode:this.$route.query?.lessonCode,
					UserCode:this.getVipNo,			/// 答题的用户编号
					IsSubmit:1,		 /// 是否交卷0：未交卷（只是部分提交答案）  1：全部结束交卷；
					RecordCode:this.subjects.RecordCode,
					AnswerList,
					OrderNo:this.$route.query?.orderno
				}
				let response = await this.submitExamAction(params)
				if (response.Flag != 2) {
					this.$Modal.info({
						title:'提示',
						content:response.Message,
						onOk:()=>{
							this.backToOrder()
						}
					})
					return
				}
				this.lotteryLink = this.getLotteryLink()
				this.showIframe = true
				
				// return response
			},
			getLotteryLink(){
				let {orderno,from} = this.$route.query
				let name = this.userInfo?.value?.binding?.name,
					timestamp = util.realNowTime().getTime(),
					payTime = util.formatDate.dateFromStr(this.orderDetail.Paytime).getTime();
				let sign = `${SecretKey}${this.getVipNo}${orderno}${timestamp}`.MD5(32)
				return `${this.luckyModalValue.Link}&pcno=${this.getVipNo}&orderno=${orderno}&name=${name}&payTime=${payTime}&platform=WebSite&timestamp=${timestamp}&sign=${sign}&uid=${this.getAccessToken}&from=${from}`
			},
			image_path_big(sku){
				return this.productMap[sku]?.image_path_big
			},
			showRateInput(q){
				if (q.select) {
					let option = q.Answers[q.select - 1]
					if (option.AnswerFlag == 1) return true
				}
				return false
			},
			specification(sku){
				return this.productMap[sku]?.specproducts[0]?.specification ||''
			},
			onValueChnage(select,q){
				if (q.Tag1 > 0 && select.length > q.Tag1) {
					select.pop()
					q.select = [...select]
				}
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.tip-title {
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 15px;
		color:$theme-color;
	}
	.topic {
		font-size:16px;
		color:$theme-color;
		font-weight: bold;
	}
	.loading {
		width:100vw;
		height:100vh;
		display:flex;
		align-items: center;
		justify-content: center;

	}
	.content {
		padding: 0 10vw;
		padding-top: 30px;
	}
	.question {
		margin-bottom: 15px;
	}
	.item {
		display:flex;
		align-items: center;
		.label {
			margin-right: 20px;
		}
	}
	.iframe {
		position:fixed;
		top: 0;
		left: 0;
		z-index: 99999;
		width: 100vw;
		height: 100vh;
		background-color:rgba(0,0,0,0.5);
		border:none;
	}
	.item {
		.serial-no {
			font-weight: bold;
			margin-bottom: 10px;
		}
		.radio {
			margin: 6px 0;
			display:block;
			height:auto;
			line-height:1.5;
		}
		.correct {
			span {
				color:$theme-color;
			}
		}
	}
	.groups {
		border-top: 2px solid #eee;
	}	
	.group {
		display:flex;
		
		.img-box {
			width:100px;
			height:100px;
			margin-right: 40px;
			img {
				width:100%;
				height:100%;
			}
		}
		.product {
			flex:1;
			.name {
				font-weight: bold;
				font-size: 16px;
				margin-top: 10px;
			}
			.p-center {
				display:flex;
				margin-top: 20px;
			}
			.price {
				color:$theme-color;
				font-weight: bold;
				font-size: 16px;
				align-self: center;
			}
			.specification {
				background-color:#F6F6F6;
				padding:3px 5px;
				border-radius: 5px;
				margin-right: 30px;
			}
		}
		.quantity {
			display:none;
			color:$theme-color;
			font-size: 16px;
			font-weight: bold;
			align-self: center;
		}
		.p-quantity {
			display:block;
			margin-left: 40px;
		}
	}
	.column-flex {
		flex-direction: column;
		align-items: flex-start;
	}
	.column-row {
		gap: 15px;
	}
	.footer {
		display:flex;
		align-items: center;
		margin-bottom: 40px;
	}
	.submit-btn {
		margin:0 auto;
		width:200px;
		border-radius: 30px;
	}
	.disabled-title {
		color:#ccc;
	}
	//移动版样式
	@media (max-width: 768px){
		.content {
			padding: 0 15px;
			&[env='app'],&[env='wechat'],&[env='wechatmini']{
				padding-top: 20px;
				.price{
					color:#e6729f
				}
				.submit-btn {
					background-color:#e6729f;
					border-color: #e6729f;
				}
				.quantity {
					color:#999;
					font-weight: normal;
				}
			}
			&[env='wechat'] {
				padding-top: 56px;
			}
			&[env='wechat'],&[env='wechatmini'] {
				.price{
					color:#BD8BCA;
				}
				.submit-btn {
					background-color:#BD8BCA;
					border-color: #BD8BCA;
				}
			}
		}
		.footer {
			margin-top: 40px;
		}
		.questions,.groups {
			background-color:white;
			padding:15px;
			border-radius: 10px;
		}
		.groups {
			margin-top: 15px;
			.group {
				margin: 10px 0;
			}
			.img-box {
				width:80px;
				height:80px;
				margin-right: 10px;
			}
			.product {
				flex:1;
				padding-left: 15px;
				.name {
					font-size: 14px;
				}
				.p-center {
					flex-direction: column;
					align-items: flex-start;
					margin-top: 10px;
				}
				.specification {
					margin-bottom: 5px;
					font-size: 12px;
				}
			}
			.quantity {
				display:block;
			}
			.p-quantity {
				display:none;
			}
		}
	}
</style>
